/* The mockup's `.scrim`, `.dialog`, `.dlg-head`, `.dlg-body` and `.dlg-foot`. */
.scrim {
  position: fixed;
  inset: 0;
  z-index: var(--z-dialog);
  display: grid;
  place-items: start center;
  padding: 10vh var(--space-4) var(--space-4);
  overflow: auto;
  background: var(--scrim);
  animation: fade var(--motion-duration) var(--motion-ease);
}

.dialog {
  inline-size: min(560px, 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
  color: var(--text);
  box-shadow: var(--shadow-dialog);
  animation: pop-in var(--motion-duration) var(--motion-ease);
}

.md {
  inline-size: min(560px, 100%);
}

.lg {
  inline-size: min(600px, 100%);
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-4) var(--space-4) 0 var(--space-6);
}

.title {
  flex: 1;
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.close {
  display: inline-flex;
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-6);
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-6) var(--space-4);
  border-top: 1px solid var(--border);
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes pop-in {
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
